import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ManageMenu from './ManageMenu'

const MainMenu = () => {
  const [activeToggle, setActiveToggle] = useState('menu')

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }
  return (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            <Link
              onClick={(e) => handleTabClick(e, 'menu')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'menu' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Menu
                <hr />
              </span>
            </Link>
          </div>

          <div className='tab-content p-3'>
            <div
              id='menu'
              className={`tab-pane fade ${
                activeToggle === 'menu' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'menu' && <ManageMenu />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MainMenu
